import { GoDashboard } from "react-icons/go";
import {
  MdAccountBalance,
  MdPersonAdd,
  MdCreditCard,
  MdCardGiftcard,
  MdKeyboard,
  // MdCardMembership,
  // MdPeople
} from "react-icons/md";
import { permissionsConstants } from "../../../constants/permissions.constants";

const {
  VIEW_CARD_REQUESTS,
  VIEW_ISSUER_CONFIGURATIONS,
  VIEW_ISSUER_MAPPINGS,
  VIEW_USERS,
  // GET_DOMAIN_CUSTOMERS,
  VIEW_CARD_STATEMENT,
  VIEW_ACTIVITY_LOG,
} = permissionsConstants;

export const menuConfig = {
  menus: [
    {
      categoryBlock: true,
      key: "dashboard",
      title: "Dashboard",
      icon: GoDashboard,
      path: "/dashboard",
      permissions: [],
    },
    {
      title: "User Management",
      key: "user-management",
      path: "/users",
      permissions: [VIEW_USERS],
      icon: MdPersonAdd,
    },
    {
      title: "Card Requests",
      key: "card-requests",
      icon: MdCreditCard,
      path: "/card-requests",
      permissions: [VIEW_CARD_REQUESTS],
    },

    // {
    //   title: "Customer Information",
    //   key: "customer-information",
    //   path: "/customers",
    //   permissions: [GET_DOMAIN_CUSTOMERS],
    //   icon: MdPeople
    // },
    // {
    //   title: "Card Records",
    //   key: "card-records",
    //   path: "/cards",
    //   permissions: [VIEW_CARDS],
    //   icon: MdCardMembership
    // },
    {
      category: true,
      title: "Card Mangement",
      key: "card-management",
      icon: MdCardGiftcard,
      permissions: [VIEW_CARD_STATEMENT],
      menus: [
        {
          title: "Card Statement",
          key: "card-statement",
          path: "/card-statement",
          permissions: [VIEW_CARD_STATEMENT],
        },
        {
          title: "Card Search",
          key: "card-search",
          path: "/card-search",
          permissions: [VIEW_CARD_STATEMENT],
        },
        {
          title: "Transaction Report",
          key: "transaction-report",
          path: "/transaction-report",
          permissions: [VIEW_CARD_STATEMENT],
        },
        /*  {
          title: "PIN Reset",
          key: "pin-reset",
          path: "/pin-reset",
          permissions: []
        },
        {
          title: "Balance Inquiry",
          key: "balance-inquiry",
          path: "/get-balance",
          permissions: []
        },
        {
          title: "Block/Unblock Card",
          key: "block-card",
          path: "/block-card",
          permissions: []
        } */
      ],
    },
    {
      category: true,
      title: "Issuer Management",
      key: "issuer-management",
      icon: MdAccountBalance,
      permissions: [VIEW_ISSUER_CONFIGURATIONS, VIEW_ISSUER_MAPPINGS],
      menus: [
        {
          title: "Issuer Mapping",
          key: "domain-issuers",
          path: "/issuer-mapping",
          permissions: [VIEW_ISSUER_MAPPINGS],
        },
        {
          title: "Issuer Configuration",
          key: "issuers-config",
          path: "/issuers/config",
          permissions: [VIEW_ISSUER_CONFIGURATIONS],
        },
      ],
    },
    {
      title: "Audit Trail",
      key: "audit-trail",
      icon: MdKeyboard,
      path: "/audit-trail",
      permissions: [VIEW_ACTIVITY_LOG],
    },
  ],
};
